import request from '../../../src/utils/request'

export const getLeaveComplianceRiskOverview = () => {
  return request({
    url: '/addon/leaveComplianceRisk/overview',
    method: 'get'
  })
}
